export default function getHashUrl(url: string): string {
  return `${url}?${__APP_HASH__}`
}
